// discontinued
export const GET_SETTINGS = 'GET_SETTINGS'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'

export const GET_USER_GENERAL_SETTINGS = 'GET_USER_GENERAL_SETTINGS'
export const UPDATE_USER_GENERAL_SETTINGS = 'UPDATE_USER_GENERAL_SETTINGS'

export const GET_ORG_CONTACTS = 'GET_ORG_CONTACTS'
export const UPDATE_ORG_CONTACTS = 'UPDATE_ORG_CONTACTS'

export const GET_ORG_GENERAL_SETTINGS = 'GET_ORG_GENERAL_SETTINGS'
export const UPDATE_ORG_GENERAL_SETTINGS = 'UPDATE_ORG_GENERAL_SETTINGS'

export const GET_ORG_LICENSE_SETTINGS = 'GET_ORG_LICENSE_SETTINGS'

export const GET_ORG_EMAIL_SETTINGS = 'GET_ORG_EMAIL_SETTINGS'
export const UPDATE_ORG_EMAIL_SETTINGS = 'UPDATE_ORG_EMAIL_SETTINGS'

export const GET_ORG_SETTINGS = 'GET_ORG_SETTINGS'
export const UPDATE_ORG_SETTINGS = 'UPDATE_ORG_SETTINGS'

export const GET_AUP_LIST = 'GET_AUP_LIST'
export const UPDATE_AUP = 'UPDATE_AUP'
export const POST_AUP = 'POST_AUP'
export const DELETE_AUP = 'DELETE_AUP'

export const GET_USER_ROLE_SETTINGS = 'GET_USER_ROLE_SETTINGS'
export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS'
export const GET_USER_ROLE_SUPERVISORS = 'GET_USER_ROLE_SUPERVISORS'

export const GET_APP_EXCLUSIONS = 'GET_APP_EXCLUSIONS'
export const POST_APP_EXCLUSION = 'POST_APP_EXCLUSION'
export const DELETE_APP_EXCLUSION = 'DELETE_APP_EXCLUSION'

export const GET_ORGANIZATIONAL_UNIT_INFO = 'GET_ORGANIZATIONAL_UNIT_INFO'
export const UPDATE_ORGANIZATIONAL_UNIT = 'UPDATE_ORGANIZATIONAL_UNIT'
export const CREATE_NEW_UNIT = 'CREATE_NEW_UNIT'
export const UPDATE_UNIT_MONITORING = 'UPDATE_UNIT_MONITORING'

export const GET_WORD_VAULT = 'GET_WORD_VAULT'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CATEGORY_EXCLUSIONS = 'GET_CATEGORY_EXCLUSIONS'
export const GET_WORD_DETAILS = 'GET_WORD_DETAILS'
export const CREATE_WORD = 'CREATE_WORD'

export const GET_WHITELIST = 'GET_WHITELIST'
export const GET_WHITELIST_SEARCH = 'GET_WHITELIST_SEARCH'
export const RESET_WHITELIST_SEARCH = 'RESET_WHITELIST_SEARCH'

export const GET_USERS_LIST = 'GET_USERS_LIST'
export const GET_WORKSTATIONS_LIST = 'GET_WORKSTATIONS_LIST'

export const GET_SUPERVISOR_GROUPS = 'GET_SUPERVISOR_GROUPS'
export const CREATE_NEW_SUPERVISOR_GROUP = 'CREATE_NEW_SUPERVISOR_GROUP'
export const UPDATE_SUP_GROUP = 'UPDATE_SUP_GROUP'
export const DELETE_SUP_GROUP = 'DELETE_SUP_GROUP'

export const SET_DEFAULT_REPORT = 'SET_DEFAULT_REPORT'

export const GET_USERS_REPORT = 'GET_USERS_REPORT'
export const GET_PHRASES_REPORT = 'GET_PHRASES_REPORT'
export const GET_WEBSITES_REPORT = 'GET_WEBSITES_REPORT'
export const GET_SUPERVISOR_REPORT = 'GET_SUPERVISOR_REPORT'
export const GET_SUPERVISOR_USER_REPORT = 'GET_SUPERVISOR_USER_REPORT'
export const GET_SUPERVISOR_LOGIN_REPORT = 'GET_SUPERVISOR_LOGIN_REPORT'
export const GET_SUPERVISOR_SINGLE_LOGIN_REPORT = 'GET_SUPERVISOR_SINGLE_LOGIN_REPORT'
